<app-personalized-dialog [loading]="loading">
    <div dialog-title>
        Create User
    </div>

    <div dialog-content>
        <!-- Content Header estilo Wizard -->
        <div class="content-header mb-3">
            <div class="content-icon">
                <lucide-icon name="user" [size]="22" [strokeWidth]="2"></lucide-icon>
            </div>
            <div>
                <div class="content-title">Create New User</div>
                <div class="content-subtitle">Register a new system user and configure role-based permissions</div>
            </div>
        </div>

        <form [formGroup]="formCreateUser" autocomplete="off" ngNativeValidate (ngSubmit)="createUser()"
            id="createUserForm">
            <div class="row g-2">
                <div class="col-md-6 mt-2">
                    <app-custom-input type="text" label="User Name" [control]="formCreateUser?.get('name')"
                        id="createName"></app-custom-input>
                </div>
                <div class="col-md-6 mt-2">
                    <app-custom-input type="email" label="User Email" [control]="formCreateUser?.get('email')"
                        id="createEmail"></app-custom-input>
                </div>
                <div class="col-md-6 mt-2">
                    <app-select label="Role" [control]="formCreateUser?.get('role')" valueField="value" textField="name"
                        [source]="allRolesOptions" placeholder="Select Role"></app-select>
                </div>
                <div *ngIf="isSalesRep" class="col-md-6 mt-2">
                    <app-select label="Liquidation Type" [control]="formCreateUser?.get('liquidation_type')"
                        valueField="code" textField="name" [source]="liquidationTypes" placeholder="Select Type"></app-select>
                </div>

                <!-- Security Credentials Card estilo Wizard -->
                <div class="col-12 mt-3">
                    <div class="section-card">
                        <div class="d-flex align-items-center gap-2 mb-2">
                            <lucide-icon name="lock" [size]="15" [strokeWidth]="2" class="text-slate-500"></lucide-icon>
                            <span class="text-slate-600 fw-semibold" style="font-size: 12px; text-transform: uppercase; letter-spacing: 0.05em;">Security Credentials</span>
                        </div>
                        <div class="row g-2">
                            <div class="col-md-6">
                                <app-custom-input type="password" label="Password" placeholder="Enter password"
                                    [control]="formCreateUser?.get('password')" id="createPassword"
                                    [showPasswordToggle]="true"></app-custom-input>
                            </div>
                            <div class="col-md-6">
                                <app-custom-input type="password" label="Confirm Password"
                                    placeholder="Confirm password" [control]="formCreateUser?.get('password2')"
                                    id="createPassword2" [showPasswordToggle]="true"></app-custom-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div dialog-actions>
        <div class="d-flex justify-content-end gap-2 w-100">
            <app-button type="button" variant="secondary" (onClick)="closeModal()">
                Cancel
            </app-button>
            <app-button type="submit" form="createUserForm" [disabled]="loading" variant="primary">
                {{ loading ? 'Creating...' : 'Create User' }}
            </app-button>
        </div>
    </div>
</app-personalized-dialog>